import { useState } from "react";
import type { Strings } from "../i18n/strings";
import { isNative } from "../lib/native";

// 웹 전용 설치 유도 FAB: 공개 웹(bwek.app) 방문자를 네이티브 앱(애드몹=수익)으로 보낸다.
// ★네이티브 앱 안에선 숨김(isNative). 토스 미니앱엔 애초에 렌더 안 됨(bwek-toss는 자체 App.tsx).
//   (토스 정책상 외부 앱 설치 유도는 금지이므로 토스 빌드엔 절대 넣지 않는다.)
const STORES = {
  // 라이브(Android).
  android: { url: "https://play.google.com/store/apps/details?id=web.bwek.app", enabled: true },
  // 심사 중 — 라이브되면 enabled:true + 실제 App Store URL(앱 ID)로 교체.
  ios: { url: "https://apps.apple.com/app/id0000000000", enabled: false },
};

type Plat = "ios" | "android" | "other";
function detectPlatform(): Plat {
  const ua = navigator.userAgent || "";
  if (/iPhone|iPad|iPod/i.test(ua)) return "ios";
  if (/Android/i.test(ua)) return "android";
  return "other";
}

const DISMISS_KEY = "bwek_install_dismissed";

export default function InstallFab({ t }: { t: Strings }) {
  const [hidden, setHidden] = useState<boolean>(() => {
    try {
      return sessionStorage.getItem(DISMISS_KEY) === "1";
    } catch {
      return false;
    }
  });

  // 이미 앱 안(네이티브)이거나, 이번 세션에 닫았으면 숨김.
  if (isNative() || hidden) return null;

  // iOS는 스토어 비활성(심사중) → 숨김. 그 외(Android·데스크톱)는 Play로.
  const plat = detectPlatform();
  const store = plat === "ios" ? STORES.ios : STORES.android;
  if (!store.enabled) return null;

  return (
    <div className="install-fab">
      <a className="install-fab-go" href={store.url} target="_blank" rel="noopener noreferrer">
        {t.getApp}
        <span className="install-fab-arrow" aria-hidden="true">
          ↗
        </span>
      </a>
      <button
        className="install-fab-x"
        onClick={() => {
          try {
            sessionStorage.setItem(DISMISS_KEY, "1");
          } catch {
            /* 무시 */
          }
          setHidden(true);
        }}
        aria-label="close"
      >
        ×
      </button>
    </div>
  );
}
